module.exports = __webpack_public_path__ + "media/customizations/regencyattentrails/back-277a2e7474ab8b251494da39c8809fe0.jpg";